import { render, staticRenderFns } from "./TheChangePasswordModal.vue?vue&type=template&id=9841d392"
import script from "./TheChangePasswordModal.vue?vue&type=script&lang=js"
export * from "./TheChangePasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports